import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=83aa9862&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=83aa9862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83aa9862",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83aa9862')) {
      api.createRecord('83aa9862', component.options)
    } else {
      api.reload('83aa9862', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=83aa9862&scoped=true&", function () {
      api.rerender('83aa9862', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iKS9SamMT0Xa/JS/teamMember.vue"
export default component.exports